import "./PreviewOrgNavbar.css";

function PreviewOrgNavbar({ pageData }) {
 const organization = pageData?.organization || {};
 const settings = pageData?.settings || {};

 const logoUrl = settings?.logo_url || organization?.logo_url || "";
 const themeMode =
  String(settings?.theme_mode || "light").trim().toLowerCase() === "dark"
   ? "dark"
   : "light";

 return (
  <div className={`preview-org-navbar preview-org-navbar-${themeMode}`}>
   <div className="preview-org-navbar-left">
    {logoUrl ? (
     <img
      src={logoUrl}
      alt={organization?.name || "Logo"}
      className="preview-org-navbar-logo"
     />
    ) : (
     <div className="preview-org-navbar-name">
      {organization?.name || "Your Organization"}
     </div>
    )}
   </div>
  </div>
 );
}

export default PreviewOrgNavbar;